(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fiche-maison"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fiche-maison__video').forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-maison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const dialog = document.querySelector('.popup-maison');
    if (!dialog) return;

    const STORAGE_KEY = 'maison-popup';
    const SUBMIT_KEY = 'maison-popup-submitted';
    const dismissDays = Number(dialog.dataset.dismissDays) || 30;
    const delay = (Number(dialog.dataset.delay) || 0) * 1000;

    const readState = () => {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || null;
      } catch {
        return null;
      }
    };

    const writeState = (status) => {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ status, at: Date.now() }));
      } catch {}
    };

    const shouldShow = () => {
      const state = readState();
      if (!state) return true;
      if (state.status === 'subscribed') return false;
      return Date.now() - state.at > dismissDays * 24 * 60 * 60 * 1000;
    };

    const close = () => {
      if (dialog.open) dialog.close();
    };

    dialog.querySelector('.popup-maison__close').addEventListener('click', close);
    dialog.addEventListener('close', () => {
      const state = readState();
      if (!state || state.status !== 'subscribed') writeState('dismissed');
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });

    const form = dialog.querySelector('.popup-maison__form');
    if (form) {
      form.addEventListener('submit', () => {
        try {
          sessionStorage.setItem(SUBMIT_KEY, '1');
        } catch {}
      });
    }

    const submittedHere = (() => {
      try {
        return sessionStorage.getItem(SUBMIT_KEY) === '1';
      } catch {
        return false;
      }
    })();

    if (dialog.querySelector('[data-popup-success]') && submittedHere) {
      try {
        sessionStorage.removeItem(SUBMIT_KEY);
      } catch {}
      writeState('subscribed');
      dialog.showModal();
      return;
    }

    if (dialog.querySelector('[data-popup-error]') && submittedHere) {
      try {
        sessionStorage.removeItem(SUBMIT_KEY);
      } catch {}
      dialog.showModal();
      return;
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.target.contains(dialog)) dialog.showModal();
      });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.target.contains(dialog)) close();
      });
      return;
    }

    if (shouldShow()) {
      setTimeout(() => {
        if (shouldShow()) dialog.showModal();
      }, delay);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
